/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Language_SvInputs */

const en_nav_language_sv = /** @type {(inputs: Nav_Language_SvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Svenska`)
};

const es_nav_language_sv = /** @type {(inputs: Nav_Language_SvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Svenska`)
};

const de_nav_language_sv = /** @type {(inputs: Nav_Language_SvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Svenska`)
};

const zh_nav_language_sv = /** @type {(inputs: Nav_Language_SvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Svenska`)
};

const ar_nav_language_sv = /** @type {(inputs: Nav_Language_SvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Svenska`)
};

const fr_nav_language_sv = /** @type {(inputs: Nav_Language_SvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Svenska`)
};

const vi_nav_language_sv = /** @type {(inputs: Nav_Language_SvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Svenska`)
};

const sw_nav_language_sv = /** @type {(inputs: Nav_Language_SvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Svenska`)
};

const th_nav_language_sv = /** @type {(inputs: Nav_Language_SvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Svenska`)
};

const bs_nav_language_sv = /** @type {(inputs: Nav_Language_SvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Svenska`)
};

const ja_nav_language_sv = /** @type {(inputs: Nav_Language_SvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Svenska`)
};

const ko_nav_language_sv = /** @type {(inputs: Nav_Language_SvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Svenska`)
};

const pt_nav_language_sv = /** @type {(inputs: Nav_Language_SvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Svenska`)
};

const it_nav_language_sv = /** @type {(inputs: Nav_Language_SvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Svenska`)
};

const sv_nav_language_sv = /** @type {(inputs: Nav_Language_SvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Svenska`)
};

const nl_nav_language_sv = /** @type {(inputs: Nav_Language_SvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Svenska`)
};

const da_nav_language_sv = /** @type {(inputs: Nav_Language_SvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Svenska`)
};

const nb_nav_language_sv = /** @type {(inputs: Nav_Language_SvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Svenska`)
};

const fi_nav_language_sv = /** @type {(inputs: Nav_Language_SvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Svenska`)
};

const pl_nav_language_sv = /** @type {(inputs: Nav_Language_SvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Svenska`)
};

const ru_nav_language_sv = /** @type {(inputs: Nav_Language_SvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Svenska`)
};

const tr_nav_language_sv = /** @type {(inputs: Nav_Language_SvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Svenska`)
};

const hi_nav_language_sv = /** @type {(inputs: Nav_Language_SvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Svenska`)
};

const id_nav_language_sv = /** @type {(inputs: Nav_Language_SvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Svenska`)
};

const ms_nav_language_sv = /** @type {(inputs: Nav_Language_SvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Svenska`)
};

const cs_nav_language_sv = /** @type {(inputs: Nav_Language_SvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Svenska`)
};

const el_nav_language_sv = /** @type {(inputs: Nav_Language_SvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Svenska`)
};

const he_nav_language_sv = /** @type {(inputs: Nav_Language_SvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Svenska`)
};

const af_nav_language_sv = /** @type {(inputs: Nav_Language_SvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Svenska`)
};

const hu_nav_language_sv = /** @type {(inputs: Nav_Language_SvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Svenska`)
};

/**
* | output |
* | --- |
* | "Svenska" |
*
* @param {Nav_Language_SvInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const nav_language_sv = /** @type {((inputs?: Nav_Language_SvInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Language_SvInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_nav_language_sv(inputs)
	if (locale === "de") return de_nav_language_sv(inputs)
	if (locale === "zh") return zh_nav_language_sv(inputs)
	if (locale === "ar") return ar_nav_language_sv(inputs)
	if (locale === "fr") return fr_nav_language_sv(inputs)
	if (locale === "vi") return vi_nav_language_sv(inputs)
	if (locale === "sw") return sw_nav_language_sv(inputs)
	if (locale === "th") return th_nav_language_sv(inputs)
	if (locale === "bs") return bs_nav_language_sv(inputs)
	if (locale === "ja") return ja_nav_language_sv(inputs)
	if (locale === "ko") return ko_nav_language_sv(inputs)
	if (locale === "pt") return pt_nav_language_sv(inputs)
	if (locale === "it") return it_nav_language_sv(inputs)
	if (locale === "sv") return sv_nav_language_sv(inputs)
	if (locale === "nl") return nl_nav_language_sv(inputs)
	if (locale === "da") return da_nav_language_sv(inputs)
	if (locale === "nb") return nb_nav_language_sv(inputs)
	if (locale === "fi") return fi_nav_language_sv(inputs)
	if (locale === "pl") return pl_nav_language_sv(inputs)
	if (locale === "ru") return ru_nav_language_sv(inputs)
	if (locale === "tr") return tr_nav_language_sv(inputs)
	if (locale === "hi") return hi_nav_language_sv(inputs)
	if (locale === "id") return id_nav_language_sv(inputs)
	if (locale === "ms") return ms_nav_language_sv(inputs)
	if (locale === "cs") return cs_nav_language_sv(inputs)
	if (locale === "el") return el_nav_language_sv(inputs)
	if (locale === "he") return he_nav_language_sv(inputs)
	if (locale === "af") return af_nav_language_sv(inputs)
	if (locale === "hu") return hu_nav_language_sv(inputs)
	return en_nav_language_sv(inputs)
});